import { useCallback, useEffect } from 'react';
import { useIsPreview } from '../hooks/useIsPreview';
export const useRefetchOnWindowFocus = ({
  refetch,
  loading
}) => {
  const isPreview = useIsPreview();
  const onWindowFocus = useCallback(() => {
    if (!loading && !isPreview) {
      refetch();
    }
  }, [refetch, loading, isPreview]);
  useEffect(() => {
    window.addEventListener('focus', onWindowFocus);
    return () => {
      window.removeEventListener('focus', onWindowFocus);
    };
  }, [onWindowFocus]);
};